import React from "react";
import cns from "classnames";
import { darken } from "polished";
import { makeStyles } from "@material-ui/core/styles";
import BaseIconButton, { BaseIconButtonProps } from "./BaseIconButton";
import { ThemeType } from "@theme";

export function DangerButton(props: BaseIconButtonProps) {
  const { children, className, variant, ...rest } = props;
  const classes = useStyles({});

  const _className = cns(className, {
    [classes.default]: variant !== "text",
    [classes.text]: variant === "text"
  });

  return (
    <BaseIconButton className={_className} variant={variant} {...rest}>
      {children}
    </BaseIconButton>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  default: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,

    "&:hover, &:active": {
      backgroundColor: darken(0.1, theme.palette.error.main)
    }
  },

  text: {
    color: theme.palette.error.main
  }
}));
